import {isMobile} from "mobile-device-detect";
import { gsap } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, gsap);

export default class Parallax {
  constructor(ctrl) {
    this.mouse = {x: 0, y: 0};
    this.controller = ctrl;
  }

  init() {
    let self = this;

    $('html').on('mousemove', function(e) {
      self.mouse = {
        x: e.pageX,
        y: e.pageY
      }
    });

    this.initParallax();
    this.initMouseParallax();
  }

  initParallax() {
    let $parents = $("[data-parallax]");

    if(!$parents.length || isMobile) return;

    let self = this;

    $parents.each(function(index, par) {
      let $parent = $(par);
      let config = $parent.data('parallax');
      let $el = $parent.find(config.el);
      $el = $el.length ? $el : $parent;
      let el = $el[0];

      let wrapped =  config.wrapped !== "false";
      let ratio = config.ratio || 1.1;
      let align = config.align || "center";

      if(wrapped) {
        $parent.css("overflow", "hidden");
      }

      gsap.set(el, {scale: wrapped ? Math.abs(ratio) : 1, transformOrigin: "center center"});

      let y = Math.round(ratio%1 * 100)/2;
      let fromY;
      let toY;

      if(align === "top") {
        fromY = 0;
        toY = 2 * y;
      } else {
        fromY = -y;
        toY = y;
      }

      let dur = 1;

      let from = {
        yPercent: fromY
      };

      let to = {
        yPercent: toY,
        duration: dur,
        ease: 'Power1.easeInOut'
      };

      let height = el.offsetHeight;
      let offset = - height * .5;

      let tween = gsap.fromTo(el, from, to);

      new ScrollMagic.Scene({
        triggerElement: par,
        triggerHook: 0.5,
        duration: height * 2,
        offset: offset
      })
        .setTween(tween)
        .addTo(self.controller)
        .addIndicators({ name: 'parallax' })
    });
  }

  initMouseParallax() {
    let $parents = $("[data-mouse-parallax]");

    if(!$parents.length || isMobile) return;

    let self = this;

    $parents.each(function(index, par) {
      let $parent = $(par);
      let config = $parent.data('mouse-parallax');
      let $el = $parent.find(config.el);
      let el = $el[0];
      let resistanceX = config.x || 0;
      let resistanceY = config.y || 0;
      let z = config.z || 0;

      $el.css("transform", "scale(1.05)");

      if(z) {
        $parent.css("perspective", "2000px");
        $el.css("transform", "scale(1.05) translateZ(" + z + "px)");
      }

      $parent.on("mousemove", (e) => {
        let x = resistanceX && -((self.mouse.x - e.currentTarget.clientWidth / 2) / resistanceX);
        let y = resistanceY && -((self.mouse.y - e.currentTarget.clientHeight / 2) / resistanceY);

        gsap.to(el, {
          x: x,
          y: y,
          rotateX: y,
          rotateY: x/8,
          duration: .5,
          ease: "Power4.EaseInOut"
        });
      });

      $parent.on("mouseleave", () => {
        gsap.to(el, {
          x: 0,
          y: 0,
          z: z,
          duration: .5,
          ease: "Power4.EaseInOut"
        });
      });
    });
  }
}


// WEBPACK FOOTER //
// ./static/js/components/Parallax.js